var _path, _path2, _rect, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStandardbank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.8483 72.5217C23.7068 67.5029 14.1795 56.7847 12.7334 43.0467C12.0954 37.2198 13.1587 24.1198 13.8392 16.8042C14.0519 13.6143 16.3487 10.9347 19.4535 10.2117C26.3012 8.76558 33.234 8 40.2519 8C47.2272 8.04253 54.2025 8.76558 61.0077 10.2117C64.1126 10.8922 66.4093 13.5717 66.6645 16.8042L66.7071 17.2721C67.6002 27.0971 68.4509 37.8578 67.7279 43.1318C65.5162 59.3367 52.8415 68.9065 41.698 72.4792L40.2519 72.947L38.8483 72.5217Z",
    fill: "url(#paint0_linear_5092_42117)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4984 16.8042C62.4558 15.5282 61.5626 14.4224 60.3292 14.1247C53.7792 12.7211 47.1441 11.998 40.4665 11.9555C33.789 11.998 27.1114 12.7211 20.6039 14.1247C19.3705 14.4224 18.4773 15.5282 18.4347 16.8042C17.9244 22.2909 16.7334 36.4967 17.3289 42.1535C18.6899 54.9558 27.9195 63.4623 38.9779 67.5879C39.5308 67.8006 40.0838 67.9707 40.6367 68.1409C40.7643 68.0983 44.4646 67.0776 44.4646 67.0776C45.1876 66.6948 47.5695 65.5464 48.2925 65.0785C55.3954 60.4425 61.4776 50.9578 63.6467 42.1535C64.9227 36.5818 63.0087 22.2909 62.4984 16.8042Z",
    fill: "url(#paint1_linear_5092_42117)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 10.7491,
    width: 52.3027,
    height: 61.7869,
    fill: "url(#pattern0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9492 56.4445C55.7771 52.5315 58.2015 47.4276 58.7544 41.9409L59.4775 41.3029C59.1797 47.8104 56.3726 52.0211 52.6723 55.7214",
    fill: "url(#paint2_linear_5092_42117)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4128 17.9526C58.4128 17.9526 44.1219 14.4224 28.1297 17.0594L27.4492 17.7399C31.5749 17.1445 35.743 16.8467 39.8687 16.8042C45.8658 16.8467 51.8203 17.4422 57.6898 18.6331L58.4128 17.9526Z",
    fill: "url(#paint3_linear_5092_42117)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9243 24.0347L58.2438 24.7578C56.2023 25.9062 53.4802 27.2672 49.6523 27.2672C49.3545 27.2672 49.0994 27.2672 48.8016 27.2672C43.4851 26.9695 40.4227 23.9922 35.9568 23.7795C35.6591 23.7795 35.3614 23.7795 35.1062 23.7795C32.6818 23.737 30.2575 24.3325 28.1309 25.5234L28.8114 24.8429C30.938 23.6519 33.3623 23.0565 35.7867 23.099C36.0844 23.099 36.3822 23.099 36.6373 23.099C41.0607 23.3542 44.2081 26.2039 49.5247 26.5016C49.8224 26.5016 50.0776 26.5016 50.3753 26.5016C53.3951 26.4591 56.3299 25.6084 58.9243 24.0347Z",
    fill: "url(#paint4_linear_5092_42117)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.435 41.3454L58.7545 42.026C57.436 43.2594 54.1185 45.5987 50.2055 45.5987C46.1224 45.5987 43.613 43.9399 41.4863 43.3019L42.1668 42.6214C44.2935 43.3019 46.8029 44.748 50.886 44.748C54.0334 44.663 57.0532 43.4721 59.435 41.3454Z",
    fill: "url(#paint5_linear_5092_42117)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8817 24.0347L58.2012 24.7152C58.4138 27.8626 58.669 31.3503 58.7541 34.4977L58.7966 37.6026L59.5197 36.922C59.5622 36.9646 59.6047 29.011 58.8817 24.0347Z",
    fill: "url(#paint6_linear_5092_42117)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9054 58.9964L55.2249 59.6769C53.1408 61.761 50.759 63.5899 48.207 65.0785L48.8876 64.398C51.482 62.9094 53.8213 61.0805 55.9054 58.9964Z",
    fill: "url(#paint7_linear_5092_42117)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8882 64.398L48.2502 65.0785L35.7031 40.3672L36.3836 39.6867L48.8882 64.398Z",
    fill: "url(#paint8_linear_5092_42117)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3402 62.2714L37.5321 62.9519L21.2422 30.1594L21.9227 29.3513L38.3402 62.2714Z",
    fill: "url(#paint9_linear_5092_42117)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0585 66.397L44.378 67.0776C42.9319 67.7581 41.4007 68.311 39.9121 68.8214L40.5926 68.1409C42.0387 67.4603 43.5274 66.8649 45.0585 66.397Z",
    fill: "url(#paint10_linear_5092_42117)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6342 68.0983L39.9112 68.8214C28.0446 64.9084 17.9645 56.3594 16.5184 42.749C15.9229 37.0071 17.1138 22.6737 17.6242 17.1019C17.6667 16.3363 18.007 15.6558 18.5174 15.1029L19.1979 14.4224C18.6875 14.9753 18.3472 15.6558 18.3047 16.4214C17.7943 21.9932 16.6034 36.2841 17.1989 42.0685C18.645 55.6789 28.7677 64.1853 40.6342 68.0983Z",
    fill: "url(#paint11_linear_5092_42117)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5826 20.1218L57.9021 20.8023C57.8171 20.0792 57.732 19.3136 57.6895 18.6757L58.4125 17.9526C58.4125 17.9526 58.5826 19.3562 58.5826 20.1218Z",
    fill: "url(#paint12_linear_5092_42117)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7251 22.2483C28.7251 21.8656 28.555 21.5253 28.2573 21.3126L23.366 17.6123C23.281 17.5273 23.1534 17.4847 23.0258 17.4847C22.8556 17.4847 22.728 17.5272 22.6004 17.6548L21.9199 18.3354C22.0475 18.2078 22.1751 18.1652 22.3452 18.1652C22.4728 18.1652 22.6004 18.2078 22.6855 18.2928L27.5767 21.9932C27.8745 22.2483 28.0446 22.5886 28.0446 22.9714V25.4383L28.7251 24.7578V22.2483Z",
    fill: "url(#paint13_linear_5092_42117)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8798 16.464C62.8373 15.1454 61.9441 14.0396 60.6682 13.7419C54.0756 12.3383 47.313 11.6153 40.5928 11.5727C33.8302 11.6153 27.1101 12.3383 20.5175 13.7419C19.2416 14.0396 18.3484 15.1454 18.3058 16.464C17.7954 22.0357 16.6045 36.3691 17.2 42.111C18.6036 55.0834 27.7906 63.4623 38.9341 67.588C39.487 67.8006 40.0399 67.9707 40.5928 68.1409L40.9756 68.0133H41.0182C42.4217 67.5454 43.7828 66.9925 45.1013 66.397L24.9409 26.7568L22.9419 25.2682C22.6441 25.0555 22.4315 24.6727 22.4315 24.2899V18.1227C22.4315 17.7825 22.6867 17.5273 23.0269 17.4847C23.1545 17.4847 23.2821 17.5273 23.3672 17.6123L28.2584 21.3126C28.5562 21.5678 28.7263 21.9081 28.7263 22.2909V24.7578C30.8529 23.5669 33.2773 22.9714 35.7016 23.0139C35.9993 23.0139 36.2545 23.0139 36.5523 23.0139C40.9756 23.2691 44.0805 26.2464 49.3971 26.5016C49.6948 26.5016 49.95 26.5016 50.2477 26.5016C54.0756 26.5016 56.7977 25.1406 58.8393 23.9922C59.0519 27.1396 59.3071 30.6273 59.3922 33.7747L59.4347 36.8795C57.0104 38.8785 53.0548 40.6224 50.8006 40.6224C47.0578 40.6224 44.5058 38.2406 40.9756 38.2406C39.3169 38.2406 37.7006 38.751 36.2971 39.6441L48.8016 64.3555C50.3328 63.4623 51.8214 62.399 53.225 61.2931C58.9243 56.6571 62.9649 50.2772 63.8155 42.026C64.5811 36.3266 63.3902 21.9932 62.8798 16.464ZM38.211 62.2714C37.8282 62.1013 37.4454 61.9311 37.0626 61.761C28.7263 57.6779 22.7717 50.9578 21.751 41.5581C21.4958 38.9636 21.6234 34.285 21.9211 29.4789L38.211 62.2714ZM50.2902 22.461C49.9925 22.461 49.7373 22.461 49.4396 22.461C44.123 22.1633 41.1883 19.3987 36.7224 19.186C36.4672 19.186 36.212 19.186 35.9993 19.186C34.6383 19.186 33.3198 19.3562 32.0438 19.739L28.1308 17.0594C32.2565 16.464 36.4247 16.1662 40.5928 16.1662C46.5899 16.2088 52.5445 16.8042 58.4139 17.9526C58.4139 17.9526 58.5415 19.3987 58.5841 20.1217C56.0746 21.6529 53.225 22.461 50.2902 22.461ZM50.3753 57.8055L43.5701 44.3652C43.2298 43.6847 42.762 43.0893 42.2091 42.6214C44.3357 43.3019 46.8451 44.9182 50.9282 44.9182C54.8412 44.9182 58.1162 42.5789 59.4772 41.3454V41.5581C58.6691 48.4058 55.3091 53.8074 50.3753 57.8055Z",
    fill: "url(#paint14_linear_5092_42117)",
    stroke: "white",
    strokeWidth: 1.4461
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_5092_42117",
    transform: "scale(0.0116279 0.00990099)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5092_42117",
    x1: 17.0813,
    y1: 10.9919,
    x2: 69.192,
    y2: 49.1395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#005CA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#002445"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5092_42117",
    x1: 18.4016,
    y1: 15.8256,
    x2: 65.6927,
    y2: 43.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#7BBBE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#78B7E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#6FAADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#6095CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#4C78B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#4A76B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#3E72B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#1E67AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#005CA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#004176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#002445"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5092_42117",
    x1: 51.9709,
    y1: 48.8986,
    x2: 59.4641,
    y2: 48.8986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5092_42117",
    x1: 27.4614,
    y1: 17.3814,
    x2: 58.409,
    y2: 17.3814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5092_42117",
    x1: 4555.41,
    y1: 25.1577,
    x2: 6273.33,
    y2: 25.1577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5092_42117",
    x1: 3106.81,
    y1: 43.4705,
    x2: 3686.76,
    y2: 43.4705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5092_42117",
    x1: 329.06,
    y1: 30.8343,
    x2: 332.398,
    y2: 30.8343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5092_42117",
    x1: 48.232,
    y1: 62.0404,
    x2: 55.919,
    y2: 62.0404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5092_42117",
    x1: 2153.47,
    y1: 52.378,
    x2: 2467.44,
    y2: 52.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5092_42117",
    x1: 2320.42,
    y1: 46.1303,
    x2: 2848.53,
    y2: 46.1303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_5092_42117",
    x1: 907.822,
    y1: 67.601,
    x2: 955.928,
    y2: 67.601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_5092_42117",
    x1: 3067.45,
    y1: 41.6096,
    x2: 4133.15,
    y2: 41.6096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_5092_42117",
    x1: 58.1395,
    y1: 496.71,
    x2: 58.1395,
    y2: 482.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_5092_42117",
    x1: 950.452,
    y1: 21.4739,
    x2: 1035.33,
    y2: 21.4739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_5092_42117",
    x1: 20.3082,
    y1: 13.3147,
    x2: 66.6852,
    y2: 45.6851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_5092_42117",
    width: 86,
    height: 101,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandardbank);
export default __webpack_public_path__ + "static/media/standardbank.a3028e9d37ba44e15b5060d28a940f4b.svg";
export { ForwardRef as ReactComponent };